// @flow

import axios from "axios";
import { EXTERNAL_CONNECTION_ERRORS } from "./constants";

export type AppRecordSaveRequest = {
  appId: string,
  appRecordId?: string,
  appRecordName: string,
  appRecordType: string,
  appRecordContents: string,
  userId: string
};

const saveAppRecord = async ({
  appId,
  appRecordId,
  appRecordName,
  appRecordType,
  appRecordContents,
  userId
}: AppRecordSaveRequest) => {
  try {
    // Ensure all required parameters are included. This is done because `saveAppRecord` is
    // a fairly complicated request, making catching errors early a priority.
    const required = [
      appId,
      appRecordName,
      appRecordType,
      appRecordContents,
      userId
    ];
    if (required.indexOf(undefined) > -1) {
      throw new Error(
        "One or more of the details to required to save this application record was not provided."
      );
    }

    // Attempt to save the application record
    const appRecordData = {
      appId,
      appRecordId,
      appRecordName,
      appRecordType,
      appRecordContents,
      userId
    };

    const savedAppRecord = await axios.post(
      "/api/shared/save-app-record",
      appRecordData
    );

    return savedAppRecord;
  } catch (error) {
    console.error("Utils - Save application record - Error:", error);

    // Note: 401 errors are handled by global axios interceptor in src/axiosConfig.js
    // Session validity is proactively checked in src/app/App.js to catch expiry before save attempts

    throw new Error(EXTERNAL_CONNECTION_ERRORS.SAVE_RECORD);
  }
};

export default saveAppRecord;
